'use client';

import { NotFoundScreen } from '@modules/shared/components/status-screens/not-found-screen/not-found-screen';
import { useWorkspaceHomePath } from 'app/_utils/workspace-home-path';

import * as Sentry from '@sentry/nextjs';
import Link from 'next/link';
import React, { useEffect } from 'react';

type Props = Readonly<{
  redirectLink?: string;
  linkText?: string;
}>;

export const NotFoundPage = ({ redirectLink, linkText = 'Home' }: Props) => {
  useEffect(() => {
    const err = new Error(`404 Not Found: ${window.location.pathname}`);
    Sentry.setTag('http.status_code', '404');
    Sentry.captureException(err, {
      level: 'error',
      extra: { path: window.location.pathname },
    });
  }, []);

  const workspaceHomePath = useWorkspaceHomePath();
  const finalHomeUrl = redirectLink || workspaceHomePath || window.location.origin;

  return (
    <NotFoundScreen>
      Let&apos;s goat you back <Link href={finalHomeUrl}>{linkText}</Link>.
    </NotFoundScreen>
  );
};
